export default "__VITE_ASSET__Dtbo3vUp__"